import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { ATTACHMENT_ACCEPT } from '../../../utils/uploadValidation';

export type IncidentWorkflowChoice = { id: number; name: string };
export type IncidentGroupChoice = { id: number; name: string };

interface Props {
  name: string;
  workflowId: number | '';
  workflows: IncidentWorkflowChoice[];
  onWorkflowChange: (workflowId: number | '') => void;
  groupId?: number;
  groups: IncidentGroupChoice[];
  groupsLoading?: boolean;
  workflowsLoading?: boolean;
  onGroupChange: (groupId: number | undefined) => void;
  urgency: string;
  onUrgencyChange: (value: string) => void;
  title: string;
  onTitleChange: (value: string) => void;
  description: string;
  onDescriptionChange: (value: string) => void;
  titleLabel?: string;
  descriptionLabel?: string;
  urgencyEmptyLabel?: string;
  allowAttachments?: boolean;
  onAttachmentsChange?: (files: File[]) => void;
}

const IncidentNovoTicketInfoFields: React.FC<Props> = ({
  name,
  workflowId,
  workflows,
  onWorkflowChange,
  groupId,
  groups,
  groupsLoading = false,
  workflowsLoading = false,
  onGroupChange,
  urgency,
  onUrgencyChange,
  title,
  onTitleChange,
  description,
  onDescriptionChange,
  titleLabel = 'Título',
  descriptionLabel = 'Descrição',
  urgencyEmptyLabel = 'Selecione',
  allowAttachments = false,
  onAttachmentsChange,
}) => (
  <Row className="g-2">
    <Col md={12}>
      <Form.Label>
        Fluxo de Trabalho <span className="text-danger">*</span>
      </Form.Label>
      <Form.Select
        aria-label={`Fluxo de ${name}`}
        value={workflowId === '' ? '' : String(workflowId)}
        disabled={workflowsLoading}
        onChange={(e) => onWorkflowChange(Number(e.target.value) || '')}
      >
        <option value="">{workflowsLoading ? 'Carregando fluxos...' : 'Selecione um fluxo'}</option>
        {workflows.map((flow) => (
          <option key={flow.id} value={String(flow.id)}>
            {flow.name}
          </option>
        ))}
      </Form.Select>
    </Col>
    <Col md={6}>
      <Form.Label>Urgência</Form.Label>
      <Form.Select
        aria-label={`Urgência de ${name}`}
        value={urgency}
        disabled={!workflowId}
        onChange={(e) => onUrgencyChange(e.target.value)}
      >
        <option value="">{urgencyEmptyLabel}</option>
        <option value="ALTA">Alta</option>
        <option value="MEDIA">Média</option>
        <option value="BAIXA">Baixa</option>
      </Form.Select>
    </Col>
    <Col md={12}>
      <Form.Label>{titleLabel}</Form.Label>
      <Form.Control
        aria-label={`${titleLabel} de ${name}`}
        value={title}
        disabled={!workflowId}
        onChange={(e) => onTitleChange(e.target.value)}
      />
    </Col>
    <Col md={12}>
      <Form.Label>{descriptionLabel}</Form.Label>
      <Form.Control
        as="textarea"
        rows={3}
        aria-label={`${descriptionLabel} de ${name}`}
        value={description}
        disabled={!workflowId}
        onChange={(e) => onDescriptionChange(e.target.value)}
      />
    </Col>
    {allowAttachments && onAttachmentsChange ? (
      <Col md={12}>
        <Form.Label>Anexos de {name}</Form.Label>
        <Form.Control
          type="file"
          accept={ATTACHMENT_ACCEPT}
          multiple
          aria-label={`Anexos de ${name}`}
          disabled={!workflowId}
          onChange={(e) => {
            const input = e.target as HTMLInputElement;
            onAttachmentsChange(Array.from(input.files || []));
          }}
        />
      </Col>
    ) : null}
    <Col md={12}>
      <Form.Label>
        Grupo para Encaminhar <span className="text-danger">*</span>
      </Form.Label>
      <Form.Select
        aria-label={`Grupo de incidentes de ${name}`}
        value={groupId || ''}
        disabled={!workflowId || groupsLoading}
        onChange={(e) => onGroupChange(Number(e.target.value) || undefined)}
      >
        <option value="">
          {!workflowId
            ? 'Selecione um fluxo primeiro'
            : groupsLoading
              ? 'Carregando grupos...'
              : groups.length === 0
                ? 'Nenhum grupo disponível para este fluxo'
                : 'Selecione um grupo'}
        </option>
        {groups.map((item) => (
          <option key={item.id} value={item.id}>
            {item.name}
          </option>
        ))}
      </Form.Select>
      <Form.Text className="text-muted">
        {workflowId
          ? 'Selecione um grupo que atende ao Primeiro Contato deste fluxo de trabalho.'
          : 'Todo chamado deve ser encaminhado para um grupo associado ao fluxo.'}
      </Form.Text>
    </Col>
  </Row>
);

export default IncidentNovoTicketInfoFields;
